module.exports = __webpack_public_path__ + "static/media/levels_2_4.17bce736.svg";